/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiVersion } from './ApiVersion';
/**
 * A single vulnerability (CVE) finding. Vulnerabilities are global CVE records from Trustify; they are not tenant-owned resources. Tenancy is determined by the device or fleet context through which they are queried.
 */
export type Vulnerability = {
  apiVersion: ApiVersion;
  /**
   * Kind is a string value representing the REST resource this object represents. Always Vulnerability.
   */
  kind: string;
  /**
   * CVE identifier (e.g. CVE-2024-1234).
   */
  cveId: string;
  /**
   * Vendor advisory identifier when available.
   */
  advisoryId?: string;
  /**
   * Name of the advisory issuer (e.g. Red Hat, NVD) when known.
   */
  issuer?: string;
  /**
   * URL to the CVE details page. Points to Red Hat Security portal for Red Hat advisories, otherwise to NVD.
   */
  link?: string;
  /**
   * Normalized severity label.
   */
  severity: Vulnerability.severity;
  /**
   * CVSS base score when available.
   */
  cvssScore?: number;
  /**
   * Short summary of the vulnerability.
   */
  description?: string;
  /**
   * Advisory publish time when known.
   */
  publishedAt?: string;
  /**
   * Image reference (name or URL) from the device context.
   */
  image?: string;
  /**
   * Immutable image digest from the device context.
   */
  imageDigest?: string;
  /**
   * Distinct devices affected by this CVE. For device context this is always 1; for fleet context it is the number of devices in the fleet running an image with this CVE; for organization-wide context it is the count across the whole organization.
   */
  affectedDevices?: number;
};
export namespace Vulnerability {
  /**
   * Normalized severity label.
   */
  export enum severity {
    CRITICAL = 'Critical',
    HIGH = 'High',
    MEDIUM = 'Medium',
    LOW = 'Low',
    NONE = 'None',
    UNKNOWN = 'Unknown',
  }
}

